import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, map } from 'rxjs';
import { DeviceInfoService } from '../../../shared/services/device-info.service';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(
    private http: HttpClient,
    private deviceInfoService: DeviceInfoService,
  ) {}

  getUserListData(params: any) {
    return this.http.get('/api/users/', { params: params });
  }

  async userEnableDisable(id: any) {
    const body = {
      device_info: await this.deviceInfoService.getDeviceDetail(),
    };
    return lastValueFrom(
      this.http
        .patch(`api/users/${id}/`, body)
        .pipe(map((response: any) => response)),
    );
  }
  async deleteUserById(id: any) {
    const body = {
      device_info: await this.deviceInfoService.getDeviceDetail(),
    };

    return lastValueFrom(
      this.http
        .post(`api/users/${id}/delete_user/`, body)
        .pipe(map((response: any) => response)),
    );
  }

  async addUser(requestData: any, params?: any) {
    const body = {
      ...requestData.data,
      device_info: await this.deviceInfoService.getDeviceDetail(),
    };
    return lastValueFrom(
      this.http
        .post(`api/users/`, body, { params: params })
        .pipe(map((response) => response)),
    );
  }
  async editUser(requestData: any) {
    const body = {
      ...requestData,
      device_info: await this.deviceInfoService.getDeviceDetail(),
    };
    return lastValueFrom(
      this.http
        .post(`api/users/${requestData.id}/`, body)
        .pipe(map((response) => response)),
    );
  }
  async updateUser(requestData: any, params: any) {
    const body = {
      ...requestData,
      device_info: await this.deviceInfoService.getDeviceDetail(),
    };
    return lastValueFrom(
      this.http
        .put(`api/users/${requestData.id}/`, body, { params: params })
        .pipe(map((response) => response)),
    );
  }
  getUserById(user_id: any, params?: any) {
    return this.http.get(`api/users/${user_id}/`, { params: params });
  }

  getSuperUserById(user_id: any) {
    return this.http.get(`admin/user/${user_id}/`, {});
  }
  deleteSuperUserById(user_id: any) {
    return this.http.post(`admin/user/${user_id}/delete/`, {});
  }

  editSuperAdmin(requestData: any, id: any) {
    const body = requestData.data;
    return this.http
      .put(`/admin/user/${id}/`, body)
      .pipe(map((response) => response));
  }
  getUserGroups(params: any) {
    return this.http.get('api/users/get_user_groups/', { params: params });
  }
  getUserTags(params: any) {
    return this.http.get('api/users/get_user_tags/', { params: params });
  }

  getUserUpdateLog(requestData?: any, params?: any) {
    const body = { ...requestData };
    return this.http
      .post('/api/events/', body, { params: params })
      .pipe(map((response) => response));
  }
  async exportUserUpdateLog(requestData?: any, params?: any) {
    const body = {
      ...requestData,
      device_info: await this.deviceInfoService.getDeviceDetail(),
    };

    return lastValueFrom(
      this.http
        .post('/api/events/export/', body, { params: params })
        .pipe(map((response) => response)),
    );
  }
  getExportLog(params?: any) {
    return this.http
      .get('/api/events/', { params: params })
      .pipe(map((response) => response));
  }

  getUserLastLocation(params?: any) {
    return this.http
      .get('/api/user_analytics/', { params: params })
      .pipe(map((response) => response));
  }

  getUserUpdateLogById(requestData?: any, params?: any) {
    const body = { ...requestData };
    return this.http
      .post('/api/events/', body, { params: params })
      .pipe(map((response) => response));
  }

  // welfare check apis

  createUserWelfareCheck(requestData?: any, params?: any) {
    const body = { ...requestData };
    return this.http
      .post('/api/user_welfare/', body, { params: params })
      .pipe(map((response) => response));
  }
  getCOnfiguredUserWelfareCheck(params?: any) {
    return this.http
      .get('/api/user_welfare/', { params: params })
      .pipe(map((response) => response));
  }

  //credential suggestion related APIs
  fetchCredentialSuggestionList(params?: any) {
    return this.http
      .get('/api/credential_suggestion/', { params: params })
      .pipe(map((response) => response));
  }
  async createCredentialSuggestion(requestData?: any, params?: any) {
    requestData = {
      ...requestData,
      device_info: await this.deviceInfoService.getDeviceDetail(),
    };
    return lastValueFrom(
      this.http
        .post('/api/credential_suggestion/', requestData, { params })
        .pipe(map((response) => response)),
    );
  }

  // identification apis (formerly licence apis)

  listIdentifications(params?: any) {
    return this.http.get(`api/credential/`, {
      params: params,
    });
  }

  async addIdentification(requestData: any, params?: any) {
    const body = {
      ...requestData,
      device_info: await this.deviceInfoService.getDeviceDetail(),
    };
    return lastValueFrom(
      this.http
        .post(`api/credential/`, body, { params: params })
        .pipe(map((response: any) => response)),
    );
  }
  async updateIdentification(id: string, requestData: any, params?: any) {
    const body = {
      ...requestData,
      device_info: await this.deviceInfoService.getDeviceDetail(),
    };
    return lastValueFrom(
      this.http
        .put(`api/credential/${id}/`, body, { params: params })
        .pipe(map((response: any) => response)),
    );
  }
  modfiyTimeAttendanceReport(requestData?: any, params?: any) {
    const body = { ...requestData };
    return this.http
      .post('/api/time_attendance/', body, { params: params })
      .pipe(map((response) => response));
  }
}
